/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Trigger type for promotion campaigns
 * @export
 */
export const PromotionCampaignTrigger = {
    TICKET_SCAN: 'TICKET_SCAN',
    unknown_default_open_api: '11184809'
} as const;
export type PromotionCampaignTrigger = typeof PromotionCampaignTrigger[keyof typeof PromotionCampaignTrigger];


export function instanceOfPromotionCampaignTrigger(value: any): boolean {
    for (const key in PromotionCampaignTrigger) {
        if (Object.prototype.hasOwnProperty.call(PromotionCampaignTrigger, key)) {
            if (PromotionCampaignTrigger[key as keyof typeof PromotionCampaignTrigger] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PromotionCampaignTriggerFromJSON(json: any): PromotionCampaignTrigger {
    return PromotionCampaignTriggerFromJSONTyped(json, false);
}

export function PromotionCampaignTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionCampaignTrigger {
    return json as PromotionCampaignTrigger;
}

export function PromotionCampaignTriggerToJSON(value?: PromotionCampaignTrigger | null): any {
    return value as any;
}

